import Vue from 'vue';
import Component from 'vue-class-component';
import { NavigationGuardNext, Route } from 'vue-router';

Component.registerHooks(['beforeRouteLeave']);

@Component
export default class ModuleReview extends Vue {
    moduleEndpoint = '';

    get moduleId(): number | null {
        return null;
    }

    async beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
        return this.markReviewed().then(() => {
            next();
        });
    }

    async canMarkReviewed() {
        return true;
    }

    async markReviewed() {
        if (this.moduleId && this.moduleEndpoint) {
            const canMark = await this.canMarkReviewed();

            if (canMark) {
                await this.$http
                    .post(
                        [
                            this.moduleEndpoint,
                            'mark_reviewed',
                            this.moduleId
                        ].join('/')
                    )
                    .catch(() => {
                        /* silently */
                    });
            }
        }
    }
}
